import React from 'react';
import { Button, Card, CardGrid, Div, Group, Header, Panel, Text, Title } from '@vkontakte/vkui';
import { Icon28BookOutline, Icon28ListCheckOutline } from '@vkontakte/icons';
import { AppShell, ScreenHeader } from '../../components/Layout/AppShell';
import { EmptyState } from '../../components/States/States';
import { DICTIONARY_PANEL } from '../../routing/routing';
import { fitTextSize } from '../../utils/text';

export function DictionaryPanel({ nav = DICTIONARY_PANEL, dictionaryWords, loading, onBack, openWord, startTraining }) {
  return (
    <Panel nav={nav}>
      <ScreenHeader title="Словарь" onBack={onBack} />
      <AppShell>
        <Group header={<Header indicator={dictionaryWords.length || undefined}>Сохранённые слова</Header>}>
          {dictionaryWords.length > 0 ? (
            <CardGrid size="l">
              {dictionaryWords.map((item) => (
                <Card key={item.word.id} mode="outline" onClick={() => openWord(item.word, DICTIONARY_PANEL)} className="cursor-pointer">
                  <Div className="text-center">
                    <Title level="2" className="break-words" style={{ fontSize: `${fitTextSize(item.word.word, 12, 22, 16)}px` }}>{item.word.word}</Title>
                    <Text className="mt-2 break-words" style={{ fontSize: `${fitTextSize(item.word.translation, 20, 14, 12)}px` }}>{item.word.translation}</Text>
                    <Text className="mt-2 text-[var(--vkui--color_text_secondary)]">
                      {item.repeat_count >= 4 ? 'Повторено' : 'Ждёт повтора'}
                    </Text>
                  </Div>
                </Card>
              ))}
            </CardGrid>
          ) : !loading ? <EmptyState /> : null}
        </Group>

        {dictionaryWords.length >= 3 ? (
          <Group>
            <Div>
              <Button size="l" stretched before={<Icon28BookOutline />} onClick={() => startTraining('dictionary', 0, DICTIONARY_PANEL)}>
                Тренировать слова
              </Button>
              <Text className="mt-3 text-center text-[var(--vkui--color_text_secondary)]">
                Тренировка соберёт слова из словаря, проверит перевод в обе стороны и покажет, что требует повтора.
              </Text>
            </Div>
          </Group>
        ) : dictionaryWords.length > 0 ? (
          <Group>
            <Div className="text-center">
              <Icon28ListCheckOutline className="mx-auto mb-2 text-[var(--vkui--color_icon_secondary)]" />
              <Text className="text-[var(--vkui--color_text_secondary)]">Для тренировки нужно минимум 3 слова в словаре.</Text>
            </Div>
          </Group>
        ) : null}
      </AppShell>
    </Panel>
  );
}
